appSocial.controller('portfolioPage', [
    '$scope', '$state', '$ionicModal', 'SocialLocaleService', 'SocialUtils', 'SocialActionService',
    function ($scope, $state, $ionicModal, SocialLocaleService, SocialUtils, SocialActionService) {
        class PortfolioPage {
            constructor() {
                this.translation = SocialLocaleService.translation;
                this.$scope = $scope;
                this.$state = $state;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {SocialActionService}
                 */
                this.actionService = SocialActionService;

                this.modal = {
                    isError: false,
                    textTitle: '',
                    textContent: '',
                    state: false,
                    isProcess: false
                }

                this.categories = [
                    {
                        id: 'current',
                        title: 'Current Portfolio',
                        active: true,
                        show: true

                    },
                    {
                        id: 'favorites',
                        title: 'Favorites',
                        active: false,
                        show: true
                    },
                ];

                const initialCategory = _.find(this.categories, {id: $state.params.category})
                if (initialCategory) {
                    this.toggleCategory(initialCategory)
                } else {
                    this.updateActiveCategory();
                }

                // console.log('STATE:::', this.$state);
                // console.log('HISTORY:::', $ionicHistory);
            }

            toggleCategory(category) {
                this.categories.forEach(item => item.active = false);
                category.active = true;
                this.updateActiveCategory();
            }

            updateActiveCategory() {
                this.activeCategory = _.find(this.categories, {active: true});
            }


        }

        return new PortfolioPage()
    }]);

